import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { RmaComponent } from './RMA/rma/rma.component';
import { MyProfileComponent } from './Admin/my-profile/my-profile.component';
import { ManageUsersComponent } from './Admin/manage-users/manage-users.component';

import { appRoutes } from './routes';
import { InfoCenterComponent } from './InfoCenter/info-center/info-center.component';
import { OrderStatusComponent } from './OrderStatus/order-status/order-status.component';
import { PricingComponent } from './Pricing/pricing/pricing.component';
import { GlobalService } from './shared/services/global';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { UserActivityComponent } from './Admin/user-activity/user-activity.component';
import { AdminInfoCenterComponent } from './Admin/info-center/info-center.component';
import { ModalComponent } from './shared/components/modal/modal.component';

import { ModalHolderDirective } from './shared/directives/modal-holder.directive';
import { ComponentFactoryService } from './shared/services/ComponentFactoryService';
import { CookieService } from 'ngx-cookie-service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AddfileComponent } from './shared/components/popups/addfile/addfile.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './shared/components/popups/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './Admin/reset-password/reset-password.component';
import { CreateUserComponent } from './Admin/create-user/create-user.component';
import { TermsandconditionsComponent } from './shared/components/popups/termsandconditions/termsandconditions.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { QuickpriceComponent } from './dashboarditems/quickprice/quickprice.component';
import { OrderstatusComponent } from './dashboarditems/orderstatus/orderstatus.component';
import { DashboardRmaComponent } from './dashboarditems/rma/rma.component';
import { ToggleComponent } from './shared/components/controls/toggle/toggle.component';
import { PreviewComponent } from './InfoCenter/preview/preview.component';
import { QuotesComponent } from './Quotes/quotes/quotes.component';
import { CheckboxComponent } from './shared/components/CPQComponents/checkbox/checkbox.component';
import { CPQPageComponent } from './shared/components/CPQComponents/cpqpage/cpqpage.component';
import { CPQScreenComponent } from './shared/components/CPQComponents/cpqscreen/cpqscreen.component';
import { CPQScreenOptionsComponent } from './shared/components/CPQComponents/cpqscreen-options/cpqscreen-options.component';
import { NumberDropdownComponent } from './shared/components/CPQComponents/number-dropdown/number-dropdown.component';
import { RadioButtonComponent } from './shared/components/CPQComponents/radio-button/radio-button.component';
import { SelectComponent } from './shared/components/CPQComponents/select/select.component';
import { TextboxComponent } from './shared/components/CPQComponents/textbox/textbox.component';
import { CPQComponent } from './Pricing/cpq/cpq.component';
import { PriceBreakComponent } from './Pricing/price-break/price-break.component';
import { ItemSummaryComponent } from './shared/components/popups/item-summary/item-summary.component';
import { OrderSummaryComponent } from './shared/components/popups/order-summary/order-summary.component';
import { RmaSummaryComponent } from './shared/components/popups/rma-summary/rma-summary.component';
import { NewsItemComponent } from './shared/components/news-item/news-item.component';
import { NewsComponent } from './News/news/news.component';
import { RmaRespondComponent } from './shared/components/popups/rma-respond/rma-respond.component';
import { ItemSearchComponent } from './shared/components/popups/item-search/item-search.component';
import { NewsItemModalComponent } from './shared/components/popups/news-item/news-item.component';
import { NewsUpdatesComponent } from './Admin/news-updates/news-updates.component';
import { ArraySortPipe, CategoryFilter, UserFilter, RangePipe } from './shared/pipes/pipes';
import { MessagesComponent } from './shared/components/popups/messages/messages.component';
import { MatNativeDateModule } from '@angular/material/core';
import { EditCategoryComponent } from './shared/components/popups/edit-category/edit-category.component';
import { VerifyEmailComponent } from './admin/verify-email/verify-email.component';
import { VertRadioButtonComponent } from './shared/components/CPQComponents/vert-radio-button/vert-radio-button.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CategoryAccordianComponent } from './shared/components/category-accordian/category-accordian.component';
import { CategoryTreeComponent } from './shared/components/category-tree/category-tree.component';
import { CategorySelectComponent } from './shared/components/category-select/category-select.component';
import { EditQuoteComponent } from './Quotes/edit-quote/edit-quote.component';
import { QuoteDetailComponent } from './shared/components/quote-detail/quote-detail.component';
import { EditSpLineComponent } from './shared/components/popups/edit-sp-line/edit-sp-line.component';
import { EditFeeComponent } from './shared/components/popups/edit-fee/edit-fee.component';
import { LeadTimeRulesComponent } from './Admin/lead-time-rules/lead-time-rules.component';
import { EditLeadTimeRuleComponent } from './Admin/edit-lead-time-rule/edit-lead-time-rule.component';


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    AdminInfoCenterComponent,
    HeaderMenuComponent,
      RmaComponent,
      MyProfileComponent,
      ManageUsersComponent,
      InfoCenterComponent,
      OrderStatusComponent,
      PricingComponent,
      UserActivityComponent,
    ModalComponent,
      ModalHolderDirective,
      AddfileComponent,
      LoginComponent,
      ForgotPasswordComponent,
      ResetPasswordComponent,
      CreateUserComponent,
      TermsandconditionsComponent,
      DashboardComponent,
      QuickpriceComponent,
      OrderstatusComponent,
    ToggleComponent,
      DashboardRmaComponent,
      PreviewComponent,
      QuotesComponent,
      CheckboxComponent,     
      CPQPageComponent,
      CPQScreenComponent,
      CPQScreenOptionsComponent,
      NumberDropdownComponent,
      RadioButtonComponent,
      SelectComponent,
      TextboxComponent,
      CPQComponent,
      PriceBreakComponent,
      ItemSummaryComponent,
      OrderSummaryComponent,
    RmaSummaryComponent,
      NewsItemComponent,
      NewsItemModalComponent,
      NewsComponent,
      RmaRespondComponent,
      ItemSearchComponent,
    NewsUpdatesComponent,
    ArraySortPipe,
      RangePipe,
    MessagesComponent,
    UserFilter,
      CategoryFilter,
      EditCategoryComponent,
    VerifyEmailComponent,
    VertRadioButtonComponent,
    CategoryAccordianComponent,
    CategoryTreeComponent,
    CategorySelectComponent,
    EditQuoteComponent,
    QuoteDetailComponent,
    EditSpLineComponent,
    EditFeeComponent,
    LeadTimeRulesComponent,
    EditLeadTimeRuleComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    RouterModule.forRoot(appRoutes),
    MatPaginatorModule,
    MatSelectModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatTooltipModule,
    MatRadioModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatAutocompleteModule,
    FontAwesomeModule,
    MatExpansionModule,
    DragDropModule
  ],
  providers: [
    GlobalService,
    ComponentFactoryService,
    CookieService,
    {
      provide: MatDialogRef,
      useValue: []
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: []
    },
    MatDatepickerModule,
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent]
  //entryComponents: [
  //  CPQComponent
  //]
})
export class AppModule { }
